<template>
   <sui-dropdown simple :options="language" text="Language" v-model="$i18n.locale" />
</template>

<script>
  export default {
    name: 'LanguageChooser',
    data() {
      return {
        currentLanguage: 'de',
        language: [
          { key: 'gb', value: 'gb', flag: 'gb', text: 'English' },
          { key: 'de', value: 'de', flag: 'de', text: 'German' },
          { key: 'ua', value: 'ua', flag: 'ua', text: 'українська' },
          // { key: 'ru', value: 'ru', flag: 'ru', text: 'Русский' }
        ]
      }
    }
  }
</script>
